import apiJson from "../config/api-json";
import {Response} from "./dto/Response";
import {AxiosResponse} from "axios";
import {MyMahiStatusType} from "../domain/verification/MyMahiStatusType";
import {getUserInfo} from "./APIUtils";

export class MyMahiAPI {

    baseUrl = "/mymahi"

    async requestMyMahiVerification(verificationId: string): Promise<string> {
        let token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        const response: AxiosResponse<Response<string>> =
            await apiJson.post(`${this.baseUrl}/prepare/${verificationId}`, null, config)
        if (response.status !== 200) {
            throw new Error(`MyMahiAPI requestMyMahiVerification: ${response.statusText}`)
        }
        return response.data.data
    }

    async retrieveMyMahiVerificationUrl(verificationId: string): Promise<string> {
        let token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        const response: AxiosResponse<Response<string>> =
            await apiJson.get(`${this.baseUrl}/url/${verificationId}`, config)
        if (response.status !== 200) {
            throw new Error(`MyMahiAPI retrieveMyMahiVerificationUrl: ${response.statusText}`)
        }
        return response.data.data
    }

    async retrieveMyMahiVerificationStatus(verificationId: string): Promise<MyMahiStatusType> {
        const response: AxiosResponse<Response<MyMahiStatusType>> =
            await apiJson.get(`${this.baseUrl}/verify/${verificationId}`)
        if (response.status !== 200) {
            throw new Error(`MyMahiAPI retrieveMyMahiVerificationStatus: ${response.statusText}`)
        }
        return response.data.data
    }

    async cancelMyMahiVerification(verificationId: string): Promise<void> {
        let token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        await apiJson.delete(`${this.baseUrl}/cancel/${verificationId}`, config)
    }
}